import React, { useState } from 'react';
import {DateWithModal} from '../../../_common/dateWithModal';
import { PostalCityInput } from "../../../_common/postalCityInput";

import countryTelData from 'country-telephone-data';
import parsePhoneNumber from 'libphonenumber-js';
import {RegexFields} from '../../../constants/utils/regexFields';
import contriesList from 'iso-3166-1-alpha-2';
import $ from 'jquery';

import liendirect from './../../../assets/images/svg/049-family.svg';
import autres from './../../../assets/images/svg/051-parents.svg';


export const ReferentSection = ({referent, setReferent, skipReferentSection, steps, setSkipReferentSection, dossierTypeOptions, accountType}) => {
    var countries = require("i18n-iso-countries");
    countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
    const gender = { male: 'Male', female: 'Female' };
    const [viewRelationShipOptions, setViewRelationshipOptions] = useState(true);
    const representativeType = {child: 1, parent:2, sibling:3, spouse:4, other:5};

    if (accountType === dossierTypeOptions.serenita) {
        return null;
    }

    return (
			<div className="card mt-4" id="ReferentSection">
				<div className="card-header py-0 pr-0 pl-4" id="headingRefDossier" role="button">
					<div className="flex-row align-items-center justify-content-lg-between" data-toggle="collapse" data-target="#accordionRefDossier" aria-expanded="true" aria-controls="accordionRefDossier">
						<h2 className="h3 font-weight-black my-auto">
							<i className={"eva eva-checkmark-circle-outline fs-4 align-middle mr-1 ml-n4" + (steps[2] === true ? " text-success" : "")}></i>
							<span className="align-middle">Informations sur le référent</span>
						</h2>
						<button type="button" className="btn btn-icon p-0 text-uppercase font-weight-demi fs-4 my-auto ml-auto m-lg-1 o-30" name="refPrincipal">
							<i className="eva eva-arrow-ios-downward-outline"></i>
						</button>
					</div>
					<hr className="mt-2 mb-0 border-gray" />
				</div>
				<div className="card-body pl-4 pr-0 collapse" id="accordionRefDossier" aria-labelledby="headingRefDossier" data-parent="#accordionCreateDossier">
					<form className="block" noValidate>
						<h4 className="h4 text-uppercase text-secondary font-weight-bolder my-2 mb-0 sr-only visually-hidden">ETAT CIVIL *</h4>
						<div className="form-inline mb-3">
							<div className="custom-control custom-radio custom-control-inline mr-6">
								<input required type="radio" id="ReferentMadame" name="SexMadameMonsieur" className="custom-control-input" checked={referent.gender === gender.female} onChange={(e) => setReferent({ ...referent, gender: gender.female })} />
								<label className="custom-control-label" htmlFor="ReferentMadame">
									Madame
								</label>
							</div>
							<div className="custom-control custom-radio custom-control-inline">
								<input type="radio" id="ReferentInputMonsieur" name="SexMadameMonsieur" className="custom-control-input" checked={referent.gender === gender.male} onChange={(e) => setReferent({ ...referent, gender: gender.male })} />
								<label className="custom-control-label" htmlFor="ReferentInputMonsieur">
									Monsieur
								</label>
							</div>
						</div>
						<div className="row gx-1">
							<div className="form-row col-xl">
								<div className="form-group col-md">
									<label className="h6 font-weight-bolder my-auto" htmlFor="PrenomReferentInput">
										Prénom *
									</label>
									<input required type="text" className="form-control" id="PrenomReferentInput" value={referent.firstName} onChange={(e) => setReferent({ ...referent, firstName: e.target.value })} />
								</div>
								<div className="form-group col-md">
									<label className="h6 font-weight-bolder my-auto" htmlFor="NomReferentInput">
										Nom *
									</label>
									<input required type="text" className="form-control" id="NomReferentInput" value={referent.lastName} onChange={(e) => setReferent({ ...referent, lastName: e.target.value })} />
								</div>
							</div>
							<div className="form-group col-12 col-md">
								<label className="h6 font-weight-bolder my-auto" htmlFor="naissanceReferentInput">
									Date de naissance *
								</label>
								<DateWithModal
									isRequired={true}
									id="ReferentInput"
									selectedDate={referent.birthDate}
									setSelectedDate={(d) => {
										setReferent({ ...referent, birthDate: d });
									}}
								/>
							</div>
						</div>
						<div className="row gx-1">
							<div className="form-group col-12 col-sm">
								<label className="h6 font-weight-bolder my-auto" htmlFor="Email">
									Email *
								</label>
								<input
									required
									type="email"
									className="form-control"
									id="Email"
									value={referent.email}
									onChange={(event) => {
										setReferent({ ...referent, email: event.target.value });
									}}
									pattern={RegexFields.email}
								/>
							</div>
							<div className="form-group col-12 col-sm">
								<label className="h6 font-weight-bolder my-auto" htmlFor={"TelephoneReferentInput"}>
									Numéro de portable
								</label>
								<div className="input-group mb-0">
									<select
										className="custom-select rounded container-tiny mr-2"
										id={"phonecode"}
										tabIndex={-98}
										value={referent.countryCode}
										onChange={(event) => {
											let pc = countryTelData.allCountryCodes[event.target.value][0].toUpperCase();
											setReferent({ ...referent, countryCode: event.target.value, phoneCountry: pc });
										}}>
										{countryTelData.allCountries.map((country, index) => {
											let dialCode = country.dialCode;
											return (
												<option key={index} value={dialCode}>
													{countries.getName(country.iso2, "fr", { select: "official" })} (+{dialCode})
												</option>
											);
										})}
									</select>
									<input
										type="tel"
										className="form-control rounded"
										id="TelephoneReferentInput"
										value={parsePhoneNumber(referent.phoneNumber, referent.phoneCountry) !== undefined ? parsePhoneNumber(referent.phoneNumber, referent.phoneCountry).formatNational() : referent.phoneNumber}
										aria-describedby="telephoneHelpBlock"
										onChange={(e) => {
											setReferent({ ...referent, phoneNumber: e.target.value });
											document.getElementById("TelephoneReferentInput").setCustomValidity("");
										}}
									/>
								</div>
							</div>
						</div>
						<div className="row gx-1">
							<div className="form-group col-md">
								<div className="form-group">
									<label className="h6 font-weight-bolder my-auto" htmlFor="AdresseReferentInput">
										Adresse *
									</label>
									<input required type="text" className="form-control" id="AdresseReferentInput" value={referent.address.addressLine1} onChange={(e) => setReferent({ ...referent, address: { ...referent.address, addressLine1: e.target.value } })} />
								</div>
								<div className="form-row">
									<PostalCityInput
										postalCode={referent.address.postalCode}
										city={referent.address.city}
										onChange={(updatedAddress) => setReferent({ ...referent, address: { ...referent.address, postalCode: updatedAddress.postalCode, city: updatedAddress.city } })}
										hasWrapper={false}
										country={referent.address.country}
										customClasses={{ city: "form-group col", postalCode: "form-group col" }}
									/>
									{/* <div className="form-group col">
										<label className="h6 font-weight-bolder my-auto" htmlFor="zipCodeReferentInput">
											Code Postal *
										</label>
										{referent.address.country === null || referent.address.country === "FR" || referent.address.country === "GF" || referent.address.country === "PF" || referent.address.country === "TF" ? (
											<input
												required
												type="text"
												className="form-control"
												id="zipCodeReferentInput"
												value={referent.address.postalCode}
												onChange={(e) => {
													setReferent({ ...referent, address: { ...referent.address, postalCode: e.target.value } });
												}}
												pattern={RegexFields.frenchZipCode}
											/>
										) : (
											<input
												required
												type="text"
												className="form-control"
												id="zipCodeReferentInput"
												value={referent.address.postalCode}
												onChange={(e) => {
													setReferent({ ...referent, address: { ...referent.address, postalCode: e.target.value } });
												}}
											/>
										)}
									</div>
									<div className="form-group col">
										<label className="h6 font-weight-bolder my-auto" htmlFor="CityReferentInput">
											Ville *
										</label>
										<input required type="text" className="form-control" id="CityReferentInput" value={referent.address.city} onChange={(e) => setReferent({ ...referent, address: { ...referent.address, city: e.target.value } })} />
									</div> */}
								</div>
								<div className="form-group">
									<div className="form-group">
										<label className="h6 font-weight-bolder my-auto" htmlFor="CountryReferentInput">
											Pays
										</label>
										<select
											className="custom-select"
											id={"CountryReferentInput"}
											tabIndex={-98}
											value={referent.address.country}
											onChange={(event) => {
												setReferent({ ...referent, address: { ...referent.address, country: event.target.value } });
											}}>
											{Object.keys(contriesList.getData()).map((country, index) => {
												return (
													<option key={index} value={country}>
														{countries.getName(country, "fr", { select: "official" })}
													</option>
												);
											})}
										</select>
									</div>
								</div>
							</div>
							<div className="block col-md">
								<p className="h6 font-weight-bolder mb-1">{accountType !== dossierTypeOptions.anticipa ? "Vous êtes" : "Relation avec la personne"} *</p>
								<div className="form-row">
									<div className="form-group col-12 col-sm col-xl-4">
										<div className={"card px-3 py-2 border-faded text-capitalize picker-card flex-row align-items-center" + (viewRelationShipOptions === true ? " active" : "")} onClick={(e) => setViewRelationshipOptions(true)}>
											<img className="img-fluid my-auto mb-2 h-5 py-1" src={liendirect} alt="lien familial direct" />
											<h2 className="h6 font-weight-bolder ml-2 pl-1 mb-0 text-uppercase">
												lien familial <br />
												direct
											</h2>
										</div>
									</div>
									<div className="form-group col-12 col-sm col-xl-4">
										<div
											className={"card px-3 py-2 border-faded text-capitalize picker-card flex-row align-items-center" + (viewRelationShipOptions === false ? " active" : "")}
											onClick={(e) => {
												setViewRelationshipOptions(false);
												setReferent({ ...referent, representativeType: representativeType.other });
											}}>
											<img className="img-fluid my-auto mb-2 h-5 py-1" src={autres} alt="autres" />
											<h2 className="h6 font-weight-bolder ml-2 pl-1 mb-0 text-uppercase">autres</h2>
										</div>
									</div>
								</div>
								{viewRelationShipOptions ? (
									<div className="form-group mb-0">
										<label className="fs-3 font-weight-bolder text-uppercase o-70" htmlFor="processus">
											TYPE DE lien
										</label>
										<div className="form-inline mb-3">
											<div className="custom-control custom-radio custom-control-inline">
												<input required type="radio" id="FilsFille" name="relationship" className="custom-control-input" checked={referent.representativeType === representativeType.child} onChange={() => setReferent({ ...referent, representativeType: representativeType.child })} />
												<label className="custom-control-label" htmlFor="FilsFille">
													Fils/Fille
												</label>
											</div>
											<div className="custom-control custom-radio custom-control-inline">
												<input type="radio" id="Parent" name="relationship" className="custom-control-input" checked={referent.representativeType === representativeType.parent} onChange={() => setReferent({ ...referent, representativeType: representativeType.parent })} />
												<label className="custom-control-label" htmlFor="Parent">
													Parent
												</label>
											</div>
											<div className="custom-control custom-radio custom-control-inline">
												<input type="radio" id="FrèreSoeur" name="relationship" className="custom-control-input" checked={referent.representativeType === representativeType.sibling} onChange={() => setReferent({ ...referent, representativeType: representativeType.sibling })} />
												<label className="custom-control-label" htmlFor="FrèreSoeur">
													Frère/Soeur
												</label>
											</div>
											<div className="custom-control custom-radio custom-control-inline">
												<input type="radio" id="Conjoint" name="relationship" className="custom-control-input" checked={referent.representativeType === representativeType.spouse} onChange={() => setReferent({ ...referent, representativeType: representativeType.spouse })} />
												<label className="custom-control-label" htmlFor="Conjoint">
													Conjoint
												</label>
											</div>
										</div>
									</div>
								) : (
									""
								)}
							</div>
						</div>
					</form>
					{accountType !== dossierTypeOptions.anticipa ? (
						""
					) : (
						<>
							<div className="o-40 mt-xs mb-4 text-center fs-3">
								<span className="o-40 mr-2">————————</span>ou<span className="o-40 ml-2">————————</span>
							</div>
							<div
								role="button"
								className="btn btn-alert-secondary p-1"
								onClick={(e) => {
									if (skipReferentSection) {
										if (steps.length > 3) {
											$("#accordionSendingMode").collapse("show");
										} else {
											$("#accordionRefDossier").collapse("hide");
										}
									} else {
										setSkipReferentSection(true);
									}
								}}>
								<span className="align-middle mx-3">Remplir plus tard</span>
								<i className="btn-icon eva eva-arrow-forward-outline align-middle fs-sm p-2"></i>
							</div>
						</>
					)}
				</div>
			</div>
		);
}